var nb = require('../../nb');
var wishItem = nb.define({
    view: {
        'class': 'wish-item clearfix',
        tag: 'li',
        'data-id': nb.bind('wishId'),
        $html: {
            tag: 'a',
            'class': 'clearfix',
            href: nb.bind('detailHref'),
            target: '_blank',
            $html: [{
                'class': 'item-left',
                $html: {
                    tag: 'img',
                    src: nb.bind('imageUrl')
                }
            }, {
                'class': 'item-right',
                $html: [{
                    'class': 'name',
                    $text: nb.bind('name')
                }, {
                    'class': 'join-date',
                    $html: [{
                        tag: 'span',
                        $text: '加入日期: '
                    }, {
                        tag: 'span',
                        $text: nb.bind('finishTime')
                    }]
                }]
            }]
        }
    }
});
var WishList = nb.define({
    parent: nb.view.List,
    view: {
        'class': 'wish-list',
        tag: 'ul'
    }
});
var wishMenu = nb.define({
    view: {
        'class': ['wish-menu', nb.bind('status')],
        $html: {
            'class': 'wish-menu-content',
            $html: [{
                'class': 'title',
                $text: "心愿单"
            }, {
                'class': 'wish-empty',
                $text: '您暂时没有心愿'
            }, {
                'class': 'wish-have',
                $html: [{
                    'class': 'scroll',
                    $html: {
                        $type: WishList,
                        $model: "wishList"
                    }
                }, {
                    'class': 'show-wish-list',
                    $html: {
                        'class': 'btn-show btn-solid-blue',
                        $html: {
                            tag: 'a',
                            href: 'wish.html',
                            $text: '浏览我的心愿单'
                        }
                    }
                }]
            }]
        }
    }
});
module.exports={
    wishMenu:wishMenu,
    wishItem:wishItem
};


//////////////////
// WEBPACK FOOTER
// ../src/js/view/header/WishMenu.js
// module id = 10
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32